<script setup>
import { ref, onMounted } from "vue";

import AttachmentItem from "@/shared/ui/upload/AttachmentItem.vue";
import { getDocumentListNotarial } from "@/entities/transaction";
import { Spinner } from "@/shared/ui/spinner";
import { Empty } from "@/shared/ui/empty";

const props = defineProps({
  uuid: {
    type: String,
    required: true,
  },
});

const loading = ref(false);
const documentList = ref([]);

async function fetchDocuments() {
  loading.value = true;
  try {
    const { success, payload } = await getDocumentListNotarial(props.uuid);
    if (success) {
      documentList.value = payload?.items || [];
    }
  } finally {
    loading.value = false;
  }
}

async function downloadFile(file) {
  const path = `${window.__CONFIG__.VUE_APP_BASE_DOMAIN}${file.file_url}`;
  try {
    const res = await fetch(path, { credentials: "include" });
    const blob = await res.blob();

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = file.file_name;
    link.click();
    URL.revokeObjectURL(url);
  } catch {
    window.open(path, "_blank");
  }
}

onMounted(() => {
  fetchDocuments();
});
</script>

<template>
  <div class="template">
    <div class="block">
      <div class="attachments">
        <div v-if="loading" class="flex justify-center items-center py-8">
          <Spinner size="sm" />
        </div>
        <Empty
          v-else-if="!documentList.length"
          :description="$t('Вложения отсутствуют')"
        />
        <div v-else class="list">
          <AttachmentItem
            v-for="file in documentList"
            :key="file.uuid"
            :file="file"
            :actions="['download']"
            @download="downloadFile(file)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.template {
  @apply flex h-full w-full overflow-x-hidden gap-5;

  .block {
    @apply flex flex-col w-1/2 h-full  rounded-2xl gap-6 overflow-hidden;
    background-color: hsl(var(--background));
    min-height: 600px !important;
    box-shadow: 0 1px 1px -0.5px rgba(0, 0, 0, 0.03),
      0 3px 3px -1.5px rgba(0, 0, 0, 0.03),
      0 20px 20px -12px rgba(0, 0, 0, 0.03);
  }
}

@media (max-width: 900px) {
  .template {
    @apply flex flex-col;

    .block {
      @apply w-full;
    }
  }
}

.attachments {
  @apply w-full bg-card rounded-2xl p-4;

  .list {
    @apply flex flex-col gap-3;
  }

  .text {
    @apply text-sm text-muted-foreground;
  }
}
</style>
